export default __webpack_public_path__ + "static/media/operations.5f125429.svg";